import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useHostContext } from 'src/core/hooks/useHostContext';
import BulkActionsMenu from 'src/modules/contentList/components/bulkActions/bulkActionsMenu';
import { Header } from 'src/modules/contentList/components/header';
import { List } from 'src/modules/contentList/components/list';
import { Routes } from 'src/shared/constants/routes';
export function ContentList() {
    const { contentListConceptToggle, bulkActionMenuToggle } = useHostContext();
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState('');
    return (_jsxs(_Fragment, { children: [bulkActionMenuToggle && location.pathname.endsWith(Routes.ListModules) && (_jsx(BulkActionsMenu, {})), contentListConceptToggle && (_jsxs("section", { children: [_jsx(Header, { onSearch: setSearchTerm }), _jsx(List, { searchTerm: searchTerm })] })), _jsx(Outlet, {})] }));
}
